<template>
    <section class="jsk-block pt-0">
      <div class="container">
          <div class="row">
              <div class="col-12 col-lg-8 offset-lg-2 px-lg-0">
                <form
                    id="registerForm"
                    @submit="checkForm"
                    >
                    <div class="row">
                        <div class="col-12 col-lg-6 col-sm-12 form-group">
                            <label for="name">{{ $t('registerPage.labelNameParent') }}</label>
                            <input
                                id="name"
                                v-model="nameP"
                                type="text"
                                name="nameP"
                                class="form-control"
                            >
                        </div>
                        <div class="col-12 col-lg-6 col-sm-12 form-group">
                            <label for="name">{{ $t('registerPage.labelNameKid') }}</label>
                            <input
                                id="name"
                                v-model="nameK"
                                type="text"
                                name="nameK"
                                class="form-control"
                            >
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-6 col-sm-12 form-group">
                            <label for="name">{{ $t('registerPage.labelPhone') }}</label>
                            <input
                                id="phone"
                                v-model="phoneP"
                                type="number"
                                name="phoneP"
                                class="form-control"
                                >
                        </div>
                        <div class="col-12 col-lg-6 col-sm-12 form-group">
                            <label for="name">{{ $t('registerPage.labelEmail') }}</label>
                            <input
                                id="email"
                                v-model="emailP"
                                type="text"
                                name="emailP"
                                class="form-control"
                            >
                        </div>
                    </div>    
                    <div class="row">
                        <div class="col-12 col-lg-12 col-sm-12 form-group">
                            <label for="name">{{ $t('registerPage.labelCourse') }}</label>
                            <select
                                id="course"
                                v-model="courseP"
                                name="courseP"
                                class="form-control"
                            >
                                <option disabled value="placeholder">{{ $t('registerPage.optionDisabled') }}</option>
                                <option value="Hello-Computer">{{ $t('helloComputerPage.title') }}</option>
                                <option value="Hello-World">{{ $t('helloWorldPage.title') }}</option>
                                <option value="Hello-JavaScript">{{ $t('helloJsPage.title') }}</option>
                                <option value="Ready-Go-Play">{{ $t('javascriptGamesPage.title') }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-12 col-sm-12 form-group text-center mt-4">
                            <input
                                type="submit"
                                :value="$t('registerPage.registerBtn')"
                                class="btn btn-xl btn-secondary btn-round text-uppercase"
                            >
                            <p v-if="errors.length" class="mt-4">
                                <b>{{ $t('privateSchoolsPage.errorText') }}</b>
                                <ul class="list-unstyled mt-3">
                                    <li v-for="error in errors" :key="error">{{ error }}</li>
                                </ul>
                            </p>
                            <p class="mt-4">{{ returnMessage }}</p>
                        </div>
                        
                    </div> 
                </form>
            </div>
          </div>
      </div>
</section>
</template>

<script>
export default {
  name: "registerForm",
  data() {
      return {
        errors: [],
        nameP: '',
        nameK: '',
        emailP: '',
        phoneP: '',
        courseP: "placeholder",
        returnMessage: ''
    }
  },
  methods:{
    checkForm: function (e) {
       e.preventDefault();

      this.errors = [];

      if (!this.nameP) {
        this.errors.push(this.$t('registerPage.namePError'));
      }
       if (!this.nameK) {
        this.errors.push(this.$t('registerPage.nameKError'));
      }
      if (!this.emailP) {
        this.errors.push(this.$t('registerPage.emailError'));
      }
       if (!this.phoneP) {
        this.errors.push(this.$t('registerPage.phoneError'));
      }
      if (!this.courseP || this.courseP == "placeholder") {
        this.errors.push(this.$t('registerPage.courseError'));
      }

      if (this.errors.length > 0) {
          return;
      }

    this.axios.post('https://www.jskids.ro/php/registerForm.php', new FormData(e.target), {headers: { 'content-type': 'application/form-data' }})
    .then(function (response) {
        this.returnMessage = response.data;
        if (this.returnMessage == "OK") {
            this.returnMessage = this.$t('registerPage.sucessMessage');
        }
    }.bind(this))
    .catch(function (error) {
        this.returnMessage = error;
        if (this.returnMessage) {
            this.returnMessage = this.$t('general.errorMessage');
        }
    }.bind(this));
      
    }
  }
};
</script>